import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.58142 21.9999L18.3488 21.9999C19.5986 22.0124 20.6038 21.0434 20.7772 19.8182L21.9735 11.4464C22.0761 10.7209 21.8785 9.97662 21.4189 9.40945C20.9583 8.8411 20.2755 8.50407 19.545 8.5115L15.0451 8.5115L15.0451 5.48831C15.0451 3.6089 13.6139 2 11.7467 2L11.2805 2L7.81271 10.3724L5.3034 10.3724C3.7089 10.3516 2.24888 11.4396 2.00921 12.9013L2.00002 12.9573L2.00002 19.5171L2.00921 19.5731C2.25543 21.0748 3.75569 22.02 5.30345 21.9997L7.58142 21.9997L7.58142 21.9999ZM19.3956 19.623C19.3097 20.2306 18.8379 20.6102 18.3608 20.6046L8.97676 20.6045L8.97677 11.2084L12.1889 3.45336C13.0011 3.66911 13.6498 4.46556 13.6498 5.48831L13.6498 9.90685L19.5489 9.9069L19.5574 9.9068C19.8424 9.90333 20.1288 10.0337 20.3348 10.288C20.5427 10.5445 20.6418 10.8972 20.5919 11.251L19.3956 19.623ZM5.28844 20.6044C4.24987 20.6196 3.52789 20.0145 3.39537 19.396L3.39537 13.078C3.53441 12.4185 4.29429 11.7533 5.28844 11.7678L7.58141 11.7678L7.58141 20.6043L5.29862 20.6043L5.28844 20.6044Z"
      fill="currentColor"
    />
  </svg>
);
